import React, { useRef, useEffect } from 'react'
import { UserBadge, PartialUser } from '@vend/react-utilities'
import classnames from 'classnames'
import { LineItemUser } from '../../../models/line-item'
export interface User extends Omit<PartialUser, 'timeUntilDeletion'> {
  email?: string
}

interface Props {
  user: User
  active: boolean
  onSelect: (user: LineItemUser) => void
  keyword?: string
}

export const SalesPerson: React.FC<Props> = ({
  user,
  active,
  onSelect,
  keyword,
}) => {
  const itemElement = useRef<HTMLLIElement>(null)

  const focusActiveItem = () => {
    if (active && itemElement.current) {
      itemElement.current.scrollIntoView()
    }
  }

  useEffect(() => {
    focusActiveItem()
  })

  return (
    <li
      className={classnames('vd-popover-list-item', {
        'vd-popover-list-item--active': active,
      })}
      onClick={() => onSelect(user as LineItemUser)}
      ref={itemElement}
    >
      <UserBadge user={user} size="small" keyword={keyword} />
    </li>
  )
}
